import {toast} from "react-toastify";
import styled from "styled-components";
import {scheduleApi} from "../../api/schedule-api";
import {useAppSelector} from "../../app/hooks";
import {scheduleState,} from "../../app/reducers/schedule-slice";
import {Confirm} from "../../types/confirm";
import DashboardDateCard from "../card/DashboardDateCard";
import {DateRangeState} from "../date/DateRangePicker";
import {DashboardScheduleLine} from "../wrapper/DashboardScheduleLine";
import ScheduleFirLineIcon from "../icons/ScheduleFirLineIcon";
import theme from "../../style/theme";
import EventBus, {EventTypes} from "../../utils/eventbus/event-bus";

interface Props {
    dateRange?: DateRangeState[];
}

export const SearchSchedulesInPeriodTable: React.FC<Props> = (
    {
        dateRange,
    }
) => {
    const {schedulePage} = useAppSelector(scheduleState);

    const handleClickScheduleDeleteButton = async (scheduleId: string) => {
        if (!dateRange) {
            return;
        }
        if (window.confirm("정말로 삭제하시겠습니까?")) {
            try {
                await scheduleApi.delete(scheduleId);
                EventBus.emit(EventTypes.SCHEDULE_DELETE);
                toast.success(Confirm.Delete);
            } catch (error) {
                console.log(error);
            }
        } else {
            alert("취소되었습니다.");
        }
    };

    return (
        <SearchSchedulesInPeriodTableContainer>
            {schedulePage.contents.length == 0 ?
                (
                    <EmptyScheduleExpandContainer>
                        <ScheduleFirLineIcon
                            fill={`${theme.palette.primitives.gray400}`}
                            width="36"
                            height="36"
                        />
                        <EmptyScheduleTitle>등록된 스케줄이 없습니다</EmptyScheduleTitle>
                    </EmptyScheduleExpandContainer>) :
                schedulePage.contents.map((schedule) => {
                    return (
                        <ScheduleRowContainer>
                            <DashboardDateCard
                                displaySchedule={schedule}
                                handleClickScheduleDeleteButton={handleClickScheduleDeleteButton}
                            />
                            <DashboardScheduleLine
                                dashboardScheduleLineType="ScheduleCheck"
                                displaySchedule={schedule}
                            />
                        </ScheduleRowContainer>
                    );
                })
            }
        </SearchSchedulesInPeriodTableContainer>
    );
};

const SearchSchedulesInPeriodTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0 10px 10px;
  box-sizing: border-box;
  width: 100%;
`;

const ScheduleRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
`;

const EmptyScheduleExpandContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 200px;
`;

const EmptyScheduleTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: ${theme.palette.primitives.gray400};
  margin: 12px;
`;
